/** Frame budget in milliseconds. */
export const FRAME_INTERVAL_MS = 16;
